import type { TourStep } from '@/components/ui/Tour';
import { CLUB_MANAGEMENT_TOUR_STEP_IDS } from './tour-constants';

function StepContent({ title, description }: { title: string; description: string }) {
  return (
    <div>
      <h3 className="mb-1 font-semibold text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
}

export function getClubManagementTourSteps(opts: {
  hasAcademyManagement: boolean;
}): TourStep[] {
  const settingsSteps: TourStep[] = [
    {
      content: (
        <StepContent
          title="Organization"
          description="Manage contact details, public site branding, sports, and directory listing from Organization at the bottom of the sidebar."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.ORGANIZATION,
      position: 'right',
    },
  ];

  if (opts.hasAcademyManagement) {
    settingsSteps.push({
      content: (
        <StepContent
          title="Academy settings"
          description="Lesson policies, make-up credits, waitlist, and age groups live under Academy settings in the Academy section."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.ACADEMY_SETTINGS,
      position: 'right',
    });
  }

  settingsSteps.push({
    content: (
      <StepContent
        title="Club settings"
        description="Configure court hire rules, membership plans, opening hours, and academy court access from Club settings."
      />
    ),
    selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.CLUB_SETTINGS,
    position: 'right',
  });

  return [
    {
      content: (
        <StepContent
          title="Your navigation is organized"
          description="Facility, Academy, and Club each have their own section in the sidebar so you can move between lessons and court operations without losing context."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.NAV_SECTIONS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Club operations"
          description="Court hire, memberships, and inventory live in this section. Public site branding is under Organization."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.CLUB_GROUP,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Court hire"
          description="Set availability, pricing, and guest checkout for public court rentals."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.COURT_HIRE,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Members"
          description="Create membership plans, enroll members, and manage household seats."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.MEMBERS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Inventory"
          description="Track equipment and hire items available to members or guests."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.INVENTORY,
      position: 'right',
    },
    ...settingsSteps,
  ];
}

/** @deprecated Use getClubManagementTourSteps */
export const clubManagementTourSteps: TourStep[] = getClubManagementTourSteps({
  hasAcademyManagement: false,
});
